import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface TrafficClickIdentifierProps {
  open: boolean;
  handleClose: () => void;
}

function CreateTrafficClickIdentifierModal({
  open,
  handleClose
}: TrafficClickIdentifierProps) {

  const token = useSelector(setUserToken);
  const outhTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();

  const [identifierName, SetIdentifierName] = useState(null);
  const [trafficSource, SetTrafficSource] = useState(null);
  const [loading, setLoading] = useState(false);

   const CreateNewTrafficClickIdentifier = async() => {
      const data = {
        identifier: identifierName,
        traffic_source: trafficSource,
      };
      try{
        setIsLoading(true);
        setLoading(true);
        if (outhTokenHeader) {
          await MetaEntitiesEndPointLogic.createMetaTrafficClickIdentifiers(outhTokenHeader, data);
        } else {
          throw new Error("User doesn't have permissions to create new themes");
        }
        if(outhTokenHeader) {
          setIsLoading(true);
          await MetaEntitiesEndPointLogic.getMetaTrafficClickIdentifiers(outhTokenHeader,dispatch);
        }
      } catch (error) {
        console.error(error, "error");
      } finally{
        setLoading(false);
        setIsLoading(false);
        handleClose();
        SetIdentifierName(null);
        await MetaEntitiesEndPointLogic.getMetaTrafficClickIdentifiers(outhTokenHeader,dispatch);
      }
    };
  

  return (
    <>
    {loading ? <SimpleBackdrop /> : (
      <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
    >
      <Paper sx={{ padding: "16px 24px 20px 24px" }}>
        <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
          Create New Traffic Click Identifier
        </DialogTitle>
        <Typography sx={{mb:1}}>Details</Typography>
        <Grid container mt={0} columnSpacing={3}>
          <Grid item xs={6}>
            <TextField
              value={identifierName}
              onChange={(e:any) => SetIdentifierName(e.target.value)}
              id="outlined-multiline-flexible"
              label="Identifier Name *" // Set your label here
              placeholder="Enter unique identifier name" // Set your placeholder here
              color="secondary"
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField 
              value={trafficSource}
              onChange={(e:any) => SetTrafficSource(e.target.value)}
              id="outlined-multiline-flexible"
              label="Traffic Source *" // Set your label here
              placeholder="Define traffic source" // Set your placeholder here
              color="secondary"
              size="small"
              fullWidth
            />
          </Grid>
        </Grid>
        <Typography
          sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
        >
          All fields are mandatory.
        </Typography>

        <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
          <Button color="secondary" onClick={handleClose} sx={{mr:1}}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" disabled={!identifierName || !trafficSource} onClick={CreateNewTrafficClickIdentifier} data-tracker="237">
          Create <DoneIcon sx={{ml:1}} />
          </Button>
        </Stack>
      </Paper>
    </Dialog>
    )}
    </>
  );
}

export default CreateTrafficClickIdentifierModal;
